import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query FeaturedCategories($locale: String, $organisationId: ID, $schemeType: ID!) {
    storeHomeFeaturedCategoriesData(locale: $locale, organisationId: $organisationId, schemeType: $schemeType) {
      employeeOrganisation {
        scheme {
          featuredCategories {
            imageUrl
            link
            label
          }
        }
      }
    }
  }
`

export const getFeaturedCategoriesQueryKey = getQueryNames(query)[0]
export default query
